import http from "../../helpers/http";
import * as helpers from "../../helpers/api";
import { toast } from "react-toastify";
import { TOAST_SETTINGS } from "../../utils/siteSettings";
import Text from "../../components/common/Text";

import {
  FETCH_SINGLE_CONTACT_CONTENT,
  FETCH_SINGLE_CONTACT_CONTENT_SUCCESS,
  FETCH_SINGLE_CONTACT_CONTENT_FAILED,
  SINGLE_CONTACT_MESSAGE,
  SINGLE_CONTACT_MESSAGE_SUCCESS,
  SINGLE_CONTACT_MESSAGE_FAILED,
  FETCH_CONTACTS_CONTENT,
  FETCH_CONTACTS_CONTENT_FAILED,
  FETCH_CONTACTS_CONTENT_SUCCESS,
  CONTACT_DELETE__MESSAGE,
  CONTACT_DELETE_MESSAGE_SUCCESS,
  CONTACT_DELETE__MESSAGE_FAILED,
  GET_FILTER_CONTACT,
  GET_FILTER_CONTACT_FAILED,
  GET_FILTER_CONTACT_SUCCESS,
} from "./actionTypes";

export const fetchContacts = () => (dispatch) => {
  dispatch({
    type: FETCH_CONTACTS_CONTENT,
    payload: null,
  });
  http
    .get("contacts")
    .then(({ data }) => {
      dispatch({
        type: FETCH_CONTACTS_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_CONTACTS_CONTENT_FAILED,
        payload: error,
      });
    });
};
export const fetchSingleContact = (contact_id) => (dispatch) => {
  dispatch({
    type: FETCH_SINGLE_CONTACT_CONTENT,
    payload: null,
  });
  http
    .get("single-contact/" + contact_id)
    .then(({ data }) => {
      //
      dispatch({
        type: FETCH_SINGLE_CONTACT_CONTENT_SUCCESS,
        payload: data,
      });
    })
    .catch((error) => {
      dispatch({
        type: FETCH_SINGLE_CONTACT_CONTENT_FAILED,
        payload: error,
      });
    });
};

export const postContact = (formData, contact_id) => (dispatch) => {
  //
  let postUrl = "";
  if (contact_id != undefined && contact_id !== null) {
    postUrl = "edit-contact/" + contact_id;
  } else {
    postUrl = "add-contact";
  }
  dispatch({
    type: SINGLE_CONTACT_MESSAGE,
    payload: null,
  });
  http
    .post(postUrl, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/contacts");
        }, 2000);
        dispatch({
          type: SINGLE_CONTACT_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: SINGLE_CONTACT_MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: SINGLE_CONTACT_MESSAGE_FAILED,
        payload: error,
      });
    });
};

export const deleteContact = (formData) => (dispatch) => {
  dispatch({
    type: CONTACT_DELETE__MESSAGE,
    payload: null,
  });
  http
    .post("delete-contact/" + formData, helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        toast.success(`${data.msg}`, TOAST_SETTINGS);
        setTimeout(() => {
          window.location.replace("/contacts");
        }, 2000);
        dispatch({
          type: CONTACT_DELETE_MESSAGE_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);
        dispatch({
          type: CONTACT_DELETE__MESSAGE_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: CONTACT_DELETE__MESSAGE_FAILED,
        payload: error,
      });
    });
};
export const getFilteredContacts = (formData) => (dispatch) => {
  dispatch({
    type: GET_FILTER_CONTACT,
    payload: null,
  });
  http
    .post("contacts", helpers.doObjToFormData(formData))
    .then(({ data }) => {
      if (data.status) {
        dispatch({
          type: GET_FILTER_CONTACT_SUCCESS,
          payload: data,
        });
      } else {
        toast.error(<Text string={data.msg} parse={true} />, TOAST_SETTINGS);

        dispatch({
          type: GET_FILTER_CONTACT_FAILED,
          payload: null,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_FILTER_CONTACT_FAILED,
        payload: error,
      });
    });
};
